import { ReactNode } from 'react'

import { useControlId } from './Field'

export function CheckboxField({
  label,
  checked,
  onChange,
  id,
  className = '',
  style,
  ...rest
}: {
  label: ReactNode
  checked: boolean
  onChange: (checked: boolean) => void
  id?: string
  className?: string
  style?: React.CSSProperties
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'checked' | 'onChange' | 'id' | 'className' | 'style' | 'type'>) {
  const controlId = useControlId(id)

  // No `.checkbox` wrapper: Material Kit's rules for it hide the native input and
  // draw a replacement from markup this does not render, leaving no control at all.
  return (
    <div className={className} style={style}>
      <label htmlFor={controlId}>
        <input
          id={controlId}
          type="checkbox"
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          {...rest}
        />{' '}
        {label}
      </label>
    </div>
  )
}
